module.exports = __webpack_public_path__ + "static/quantum-email-ed3ff5fcc98d4fb2b10c86cfc6bfb377.jpeg";